import axios from "axios";
import AxiosInstance1 from "../AxiosInstance/AxiosInstance1";

const GetInitiativeTimeline = async (IdeaId, UserId) => {
  const userdata = JSON.parse(sessionStorage.getItem("user"));
  const employeeId = userdata?.employeeId;
  const accessToken = sessionStorage.getItem("access_token");
  try {
    const response = await AxiosInstance1.get(
      `/api/InitiativeDetail/GetInitiativeTimeline`,
      {
        params: { IdeaId, UserId }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching initiative timeline:", error);
    throw new Error("Failed to fetch initiative timeline");
  }
};

export default GetInitiativeTimeline;
